import React, { useState } from 'react';
import FormField from '../components/FormField';
import MyButton from '../components/MyButton';
import { validateInviteCode, generatePubCode } from '../api/user';
import RowColLayout from '../components/RowColLayout';
import AvisoPrivacidad from '../components/AvisoPriv';

// Helper para pausar la ejecución
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const InviteCode = ({ onValidated }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);  // Track checkbox state

  //   // Función para el flujo "No tengo código"
  const handleGeneratePublic = async () => {
    console.log("--- Inicio de Flujo: Registro Público ---");
    
    if (!isChecked) {
      console.warn("Intento de generación sin aceptar aviso de privacidad.");
      alert("Por favor, acepta el Aviso de Privacidad primero.");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      // 1. Generar el código en el backend
      console.log("Paso 1: Llamando a generatePubCode...");
      const res = await generatePubCode();
      
      console.log("Respuesta de generatePubCode recibida:", res);
      
      const newCode = res.invite_code;
      if (!newCode) {
        throw new Error("El backend no devolvió un 'invite_code' válido.");
      }

      console.log("Código generado con éxito:", newCode);
      setCode(newCode); // Feedback visual en el input
      await sleep(1000);

      // 2. Validarlo automáticamente
      console.log("Paso 2: Validando el código generado automáticamente...");
      const data = await validateInviteCode(newCode);
      
      console.log("Validación exitosa. Datos de registro:", data);

      if (data && data.registration_token) {
        console.log("Token de registro obtenido. Ejecutando onValidated...");
        onValidated(data);
      } else {
        console.error("La validación no devolvió un token de registro:", data);
        throw new Error("No se recibió el token de registro tras la validación.");
      }

    } catch (err) {
      // Log detallado del error
      console.error("--- ERROR EN FLUJO PÚBLICO ---");
      console.error("Mensaje:", err.message);
      
      if (err.response) {
        console.error("Datos del error de la API:", err.response.data);
        console.error("Status del error:", err.response.status);
      }
      
      setError("No se pudo completar el acceso automático. Intente ingresar el código manualmente.");
    } finally {
      console.log("--- Fin de ejecución: handleGeneratePublic ---");
      setLoading(false);
    }
  };

  const handleValidate = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    if (!isChecked) {  // Check if the checkbox is clicked
      alert("Por favor, acepta el Aviso de Privacidad.");
      setLoading(false);
      return;
    }

    try {
      const data = await validateInviteCode(code);
      console.log("Backend response from InviteCode submit")
      console.log(data)
      onValidated(data);
    } catch (err) {
      const apiError = err?.response?.data;
      let message = 'El código de invitación no es válido';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (checked) => {
    setIsChecked(checked);
  };

  return (
    <section>
      <RowColLayout>
        <h3 className='text-center'>Ingresa tu código</h3>
      </RowColLayout>

      <RowColLayout>
        <form onSubmit={handleValidate}>
          <FormField
            label="Código de Invitado"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />

          <div className="d-flex justify-content-center mt-3">
            <MyButton text="Validar" type="submit" disabled={!code.trim()} loading={loading}/>
          </div>
        </form>
      </RowColLayout>

      <RowColLayout>
        <h4 className='text-center'>¿No cuentas con un código?</h4>
      </RowColLayout>

      <div className='row d-flex justify-content-center m-0 p-0'>
        <div className='col-8 d-flex justify-content-center m-0 p-0'>
          <MyButton 
            text="¡Da click aquí!" 
            onClick={handleGeneratePublic}
            disabled={loading}
            // variant="secondary" // Asumiendo que MyButton acepta variantes
          />
        </div>
      </div>
      

      <RowColLayout>
        <AvisoPrivacidad onCheckboxChange={handleCheckboxChange} />
      </RowColLayout>

      <RowColLayout>
        <h5>¿Ya tienes un registro?</h5>
        <a href="https://www.copaskimx.com/">
          <h5>Iniciar Sesión</h5>
        </a>
      </RowColLayout>
      
      <RowColLayout>
        {error && (
          <div className="alert alert-danger text-center mt-3" role="alert">
            {error}
          </div>
        )}
      </RowColLayout>
    </section>
  );
};

export default InviteCode;
// import React, { useState } from 'react';
// import FormField from '../components/FormField';
// import MyButton from '../components/MyButton';
// import { validateInviteCode, generatePubCode } from '../api/user';
// import RowColLayout from '../components/RowColLayout';
// import AvisoPrivacidad from '../components/AvisoPriv';

// const InviteCode = ({ onValidated }) => {
//   const [code, setCode] = useState('');
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [isChecked, setIsChecked] = useState(false);

//   const handleCheckboxChange = (checked) => {
//     setIsChecked(checked);
//   };

//   // Función para validar código manual
//   const handleValidate = async (e) => {
//     if (e) e.preventDefault();
    
//     if (!isChecked) {
//       alert("Por favor, acepta el Aviso de Privacidad.");
//       return;
//     }

//     setError(null);
//     setLoading(true);

//     try {
//       const data = await validateInviteCode(code);
//       onValidated(data); // Pasa el registration_token al padre
//     } catch (err) {
//       setError(err?.response?.data?.detail || 'El código de invitación no es válido');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Función para el flujo "No tengo código"
//   const handleGeneratePublic = async () => {
//     if (!isChecked) {
//       alert("Por favor, acepta el Aviso de Privacidad primero.");
//       return;
//     }

//     setError(null);
//     setLoading(true);

//     try {
//       // 1. Generar el código en el backend
//       const res = await generatePubCode();
//       const newCode = res.invite_code;
//       setCode(newCode); // Lo mostramos en el input por feedback visual

//       // 2. Validarlo automáticamente para obtener el token de registro
//       const data = await validateInviteCode(newCode);
//       onValidated(data);

//     } catch (err) {
//       setError("No se pudo generar el acceso público. Intente con un código manual.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="py-4">
//       <RowColLayout>
//         <h4 className='text-center mb-4'>Registro Copa Ski 2026</h4>
//       </RowColLayout>

//       {/* Formulario Manual */}
//       <RowColLayout>
//         <form onSubmit={handleValidate} className="mb-4">
//           <FormField
//             label="¿Tienes un código de invitado? Ingrésalo aquí:"
//             placeholder="Ej: ABDS..."
//             value={code}
//             onChange={(e) => setCode(e.target.value)}
//           />
//           <div className="d-flex justify-content-center mt-3">
//             <MyButton 
//               text="Validar Código" 
//               type="submit" 
//               disabled={!code.trim() || loading} 
//               loading={loading}
//             />
//           </div>
//         </form>
//       </RowColLayout>

//       <hr />

//       {/* Opción Pública */}
//       <RowColLayout>
//         <div className="text-center my-4 p-3 border rounded bg-light">
//           <h5>¿No tienes un código?</h5>
//           <p className="text-muted small">Puedes generar un código de acceso público para continuar con tu registro.</p>
//           <MyButton 
//             text="Generar Código Público" 
//             onClick={handleGeneratePublic}
//             disabled={loading}
//             // variant="secondary" // Asumiendo que MyButton acepta variantes
//           />
//         </div>
//       </RowColLayout>

//       <RowColLayout>
//         <AvisoPrivacidad onCheckboxChange={handleCheckboxChange} />
//       </RowColLayout>

//       <RowColLayout>
//         <div className="text-center mt-4">
//             <p>¿Ya tienes un registro completo?</p>
//             <a href="https://www.copaskimx.com/" className="btn btn-link">
//               Iniciar Sesión
//             </a>
//         </div>
//       </RowColLayout>
      
//       {error && (
//         <RowColLayout>
//           <div className="alert alert-danger text-center mt-3" role="alert">
//             {error}
//           </div>
//         </RowColLayout>
//       )}
//     </section>
//   );
// };

// export default InviteCode;